import { render, staticRenderFns } from "./SellStockProducts.vue?vue&type=template&id=13831dec&scoped=true"
import script from "./SellStockProducts.vue?vue&type=script&lang=js"
export * from "./SellStockProducts.vue?vue&type=script&lang=js"
import style0 from "./SellStockProducts.vue?vue&type=style&index=0&id=13831dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13831dec",
  null
  
)

export default component.exports